import React, {
  useEffect,
  useState,
  useCallback,
  useLayoutEffect,
  useRef
} from "react";
import "./allProperties.css";
import { useNavigate, useLocation } from "react-router-dom";
import FiltersProperty from "../../components/FiltersProperty";
import {
  listAllApprovedProperties,
  deletePropertiesBatch,
} from "../../../services/api/properties";
import { listRealEstates } from "../../../services/api/real_estates";
import {
  listFavorites,
  addFavorite,
  removeFavorite,
} from "../../../services/api/user_favorites";
import {
  FaRegStar,
  FaStar,
  FaMapMarkerAlt,
  FaBed,
  FaSwimmingPool,
  FaCar,
  FaUmbrellaBeach,
  FaChevronLeft,
  FaChevronRight,
  FaArrowUp
} from "react-icons/fa";
import { MdBathroom, MdLineWeight } from "react-icons/md";
import { GiBed, GiBarbecue } from "react-icons/gi";
import { RiSofaFill } from "react-icons/ri";
import { TbBeach, TbCashRegister } from "react-icons/tb";
import { AiFillLike } from "react-icons/ai";
import { IoSadOutline } from "react-icons/io5";
import { BsFillPostcardFill, BsCheckSquareFill } from "react-icons/bs";
import { MdCheckBoxOutlineBlank, MdExpandLess, MdExpandMore } from "react-icons/md";
import { formatMoney } from "../../../utils/formatMoney";
import { useUser } from "../../../utils/UserContext";
import { decodeJWT } from "../../../utils/getUserByToken";
import ModalConfirmAction, { ModalMessage } from "../../components/ModalConfirmAction";

export default function AllProperties({
  especific_database,
  favorites,
  realEstateInfoById: realEstateInfoMapFromProps,
  undefined_mensage,
  title_visible,
  filters_visible = true,
  storageContext = "allProperties",
  forcedTotal,
  externalPageControl,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useUser();
  const LIMIT = 30;

  const [isAdminOrAssistant, setIsAdminOrAssistant] = useState(() => {
    try {
      const pos = decodeJWT()?.position?.toLowerCase();
      return pos === "admin" || pos === "assistant";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (!currentUser?.nivel) return;
    const nivel = currentUser.nivel.toLowerCase();
    setIsAdminOrAssistant(nivel === "administrador" || nivel === "assistente");
  }, [currentUser]);

  const isExternalControl = !!externalPageControl;
  const [internalPage, setInternalPage] = useState(1);
  const currentPage = isExternalControl
    ? externalPageControl.currentPage
    : internalPage;
    

  const [internalTotal, setInternalTotal] = useState(0);
  const scrollTargetRef = useRef(null);
  const touchStartPos = useRef({ x: 0, y: 0 });
  const touchMoved = useRef(false);
  const lastTouchTime = useRef(0);

  let effectiveTotalItems = 0;
  if (forcedTotal !== undefined) {
    effectiveTotalItems = forcedTotal;
  } else if (especific_database) {
    effectiveTotalItems = especific_database.length;
  } else {
    effectiveTotalItems = internalTotal;
  }

  const monthNames = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  const totalPages = Math.ceil(effectiveTotalItems / LIMIT) || 1;

  const [activeFilters, setActiveFilters] = useState({});
  const [userFavorites, setUserFavorites] = useState([]);
  const [database, setDatabase] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState(
    () => localStorage.getItem("viewMode") || "cards",
  );

  const [realEstateInfoById, setRealEstateInfoById] = useState(
    realEstateInfoMapFromProps || {},
  );

  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletingBatch, setDeletingBatch] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showSelectedList, setShowSelectedList] = useState(false);

  const toggleSelectionMode = () => {
    setIsSelectionMode((prev) => !prev);
    setSelectedIds(new Set());
    setShowSelectedList(false);
  };

  const toggleSelectId = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const handleConfirmBatchDelete = async () => {
    const count = selectedIds.size;
    setDeletingBatch(true);
    try {
      await deletePropertiesBatch([...selectedIds]);
      setDatabase((prev) => prev.filter((p) => !selectedIds.has(p.id)));
      setFilteredData((prev) => prev.filter((p) => !selectedIds.has(p.id)));
      setSelectedIds(new Set());
      setIsSelectionMode(false);
      setShowSuccessModal(count);
    } catch (err) {
      console.error("Erro ao deletar em lote:", err);
    } finally {
      setDeletingBatch(false);
      setShowDeleteModal(false);
    }
  };

  const changeViewMode = (mode) => {
    setViewMode(mode);
    localStorage.setItem("viewMode", mode);
  };

  const handleFilterChange = useCallback((newFilters) => {
    setActiveFilters((prevFilters) => {
      if (JSON.stringify(prevFilters) === JSON.stringify(newFilters)) {
        return prevFilters;
      }
      return newFilters;
    });
    setInternalPage(1);
  }, []);

  const handlePageChange = (newPage) => {
    window.scrollTo(0, 0);
    if (isExternalControl) {
      externalPageControl.setPage(newPage);
    } else {
      setInternalPage(newPage);
    }
  };

  useEffect(() => {
    async function fetchSmart() {
      if (especific_database) {
        const active = especific_database.filter(
          (p) => p.status === "approved",
        );
        setDatabase(active);
        setFilteredData(active);

        if (favorites) {
          const favoritesIds = favorites.map((fav) =>
            typeof fav === "object" ? fav.id : fav,
          );
          setUserFavorites(favoritesIds);
        } else {
          try {
            const favs = await listFavorites();
            setUserFavorites(favs.favorites.map((f) => f.id));
          } catch (e) {}
        }

        if (!realEstateInfoMapFromProps) {
          try {
            const realEstatesData = await listRealEstates();
            const infoMap = {};
            realEstatesData.forEach((re) => {
              infoMap[re.id] = {
                name:
                  re.nomeFantasia || re.nome || re.razaoSocial || re.full_name,
                type: re.type,
              };
            });
            setRealEstateInfoById(infoMap);
          } catch (e) {
            console.error("Erro ao carregar imobiliárias", e);
          }
        }

        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const [propertiesResponse, favs, realEstatesData] = await Promise.all([
          listAllApprovedProperties(currentPage, LIMIT, activeFilters),
          listFavorites(),
          listRealEstates(),
        ]);

        const itemsList = propertiesResponse.properties || [];
        const totalCount = propertiesResponse.total || 0;

        setInternalTotal(totalCount);

        const infoMap = {};
        realEstatesData.forEach((re) => {
          infoMap[re.id] = {
            name: re.nomeFantasia || re.nome || re.razaoSocial || re.full_name,
            type: re.type,
          };
        });
        setRealEstateInfoById(infoMap);

        const favoritesIds = favs.favorites.map((f) => f.id);
        setUserFavorites(favoritesIds);

        setDatabase(itemsList);
        setFilteredData(itemsList);
      } catch (err) {
        console.error("Erro ao buscar dados em AllProperties:", err);
        setDatabase([]);
        setFilteredData([]);
        setInternalTotal(0);
      } finally {
        setLoading(false);
      }
    }

    fetchSmart();
  }, [
    especific_database,
    favorites,
    realEstateInfoMapFromProps,
    currentPage,
    activeFilters,
  ]);

  useLayoutEffect(() => {
    if (!loading && filteredData.length > 0) {
      const savedScroll = sessionStorage.getItem(`scrollPos_${storageContext}`);

      if (savedScroll) {
        const timer = setTimeout(() => {
          window.scrollTo({
            top: parseInt(savedScroll),
            behavior: "instant",
          });
          sessionStorage.removeItem(`scrollPos_${storageContext}`);
        }, 100);

        return () => clearTimeout(timer);
      }
    }
  }, [loading, filteredData, storageContext]);

  const toggleFavorite = (id) => {
    const isFavorited = userFavorites.includes(id);
    if (isFavorited) {
      removeFavorite(id);
      setUserFavorites(userFavorites.filter((favId) => favId !== id));
    } else {
      addFavorite(id);
      setUserFavorites([...userFavorites, id]);
    }
  };

  const handleCardClick = (property) => {
    const scrollPosition = window.scrollY;
    sessionStorage.setItem(
      `scrollPos_${storageContext}`,
      scrollPosition.toString(),
    );

    navigate(`/dashboard/imoveis/${property.id}`, {
      state: {
        property,
        database,
        contextData: filteredData,
        backgroundLocation: location,
        storageContext,
      },
    });
  };

 useEffect(() => {
    const handleScroll = (e) => {
      // O evento pode vir do document ou de uma div. Vamos pegar o alvo correto.
      const target = e.target;
      
      // Pega a posição do scroll dependendo de onde ele está acontecendo
      const scrollTop = target.scrollTop || window.scrollY || 0;

      if (scrollTop > 300) {
        setShowScrollTop(true);
        // Salva a referência de QUAL elemento está rolando a tela
        scrollTargetRef.current = target === document ? window : target;
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll, true);
    
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, []);

  const scrollToTop = () => {
    if (scrollTargetRef.current) {
      // Manda a div específica que estava rolando voltar para o topo
      scrollTargetRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      // Fallback de segurança
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const formatarComissao = (valor) => {
    if (valor === null || valor === undefined || valor === "") {
      return "Não Informado";
    }
    const numValor = parseFloat(valor);
    if (numValor === 0 || Number(valor) === 999) {
      return "Fifty";
    }
    const v = String(valor).trim().toLowerCase();
    if (v === "fifty") {
      return "Fifty";
    }
    const num = parseFloat(v);
    if (isNaN(num)) {
      return valor;
    }
    if (num > 0 && num < 1) {
      return `${(num * 100).toFixed(0)}%`;
    }
    return `${num}%`;
  };

  const checkFeature = (card, key, textTerms = []) => {
    if (card[key] === true || card[key] === "true") return true;
    if (card.outrasInfo && textTerms.length > 0) {
      const infoLower = card.outrasInfo.toLowerCase();
      return textTerms.some((term) => infoLower.includes(term.toLowerCase()));
    }
    return false;
  };

  const propertiesToRender = filteredData;
  const noData = !loading && propertiesToRender.length === 0;

  return (
    <>
      <h1
        className="page-title"
        style={
          title_visible === false ? { display: "none" } : { display: "flex" }
        }
      >
        FILTRAR IMÓVEIS
      </h1>

      {filters_visible && (
        <FiltersProperty onFilterChange={handleFilterChange} />
      )}

      <div className="container-bts-property-visibility">
        {isAdminOrAssistant && (
          <button
            title={isSelectionMode ? "Cancelar Seleção" : "Selecionar Imóveis"}
            className={`bt-selection-mode${isSelectionMode ? " active" : ""}`}
            onClick={toggleSelectionMode}
          >
            <i>
              {isSelectionMode ? <BsCheckSquareFill /> : <MdCheckBoxOutlineBlank />}
            </i>
          </button>
        )}
        <div className="bt-property-visibility">
          <button
            title="Visualização em Cards"
            className={viewMode === "cards" ? "active" : ""}
            onClick={() => changeViewMode("cards")}
          >
            <i>
              <BsFillPostcardFill />
            </i>
          </button>
          <button
            title="Visualização em Linhas"
            className={viewMode === "lines" ? "active" : ""}
            onClick={() => changeViewMode("lines")}
          >
            <i>
              <MdLineWeight />
            </i>
          </button>
        </div>
      </div>

      {loading ? (
        <div
          className="loading-message"
          style={{ textAlign: "center", padding: "50px", fontSize: "1.2rem" }}
        >
          <p>Carregando imóveis...</p>
        </div>
      ) : noData ? (
        <div className="undefined-mensage">
          <p>
            {undefined_mensage || "Nenhum Imóvel Encontrado"}
            <i>
              <IoSadOutline />
            </i>
          </p>
        </div>
      ) : (
        <>
          <section className="cards-container">
            {viewMode === "cards" ? (
              propertiesToRender.map((card) => {
                const showLazer = checkFeature(card, "has_full_leisure", [
                  "Lazer Completo",
                ]);
                const showPiscina = checkFeature(card, "has_pool", ["Piscina"]);
                const showMobiliado = checkFeature(card, "is_furnished", [
                  "Mobiliado",
                ]);
                const showEdicula = checkFeature(card, "has_edicule", [
                  "Com Edícula",
                  "Edicula",
                  "Edícula",
                ]);
                const showFrenteMar = checkFeature(card, "is_seafront", [
                  "Frente ao Mar",
                  "Frente Mar",
                ]);
                const showVistaMar = checkFeature(card, "has_sea_view", [
                  "Vista ao Mar",
                  "Vista para o Mar",
                  "Vista Mar",
                ]);
                const showProxPraia = checkFeature(card, "is_near_beach", [
                  "Próximo a Praia",
                  "Perto da Praia",
                ]);

                const isSelected = selectedIds.has(card.id);
                return (
                  <article
                    key={card.id}
                    className={`property-card${isSelectionMode ? " selection-mode" : ""}${isSelected ? " card-selected" : ""}`}
                    onTouchStart={isSelectionMode ? (e) => {
                      touchStartPos.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
                      touchMoved.current = false;
                    } : undefined}
                    onTouchMove={isSelectionMode ? (e) => {
                      if (touchMoved.current) return;
                      const dx = Math.abs(e.touches[0].clientX - touchStartPos.current.x);
                      const dy = Math.abs(e.touches[0].clientY - touchStartPos.current.y);
                      if (dx > 10 || dy > 10) touchMoved.current = true;
                    } : undefined}
                    onTouchEnd={isSelectionMode ? (e) => {
                      if (touchMoved.current) return;
                      if (Date.now() - lastTouchTime.current < 50) return;
                      lastTouchTime.current = Date.now();
                      toggleSelectId(card.id);
                    } : undefined}
                    onClick={isSelectionMode ? () => {
                      if (touchMoved.current) return;
                      if (Date.now() - lastTouchTime.current < 500) return;
                      toggleSelectId(card.id);
                    } : undefined}
                  >
                    {isSelectionMode ? (
                      <button
                        className="bt-favorite bt-selection-checkbox"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleSelectId(card.id);
                        }}
                      >
                        <i>
                          {isSelected ? <BsCheckSquareFill /> : <MdCheckBoxOutlineBlank />}
                        </i>
                      </button>
                    ) : (
                      <button
                        className="bt-favorite"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleFavorite(card.id);
                        }}
                      >
                        <i>
                          {userFavorites.includes(card.id) ? (
                            <FaStar />
                          ) : (
                            <FaRegStar />
                          )}
                        </i>
                      </button>
                    )}
                    <div
                      className="property-image"
                      onTouchEnd={isSelectionMode ? (e) => {
                        if (touchMoved.current) return;
                        e.stopPropagation();
                        lastTouchTime.current = Date.now();
                        toggleSelectId(card.id);
                      } : undefined}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (isSelectionMode) {
                          if (Date.now() - lastTouchTime.current < 500) return;
                          toggleSelectId(card.id);
                          return;
                        }
                        handleCardClick(card);
                      }}
                    >
                      {card.area > 0 && <span>{card.area} m²</span>}

                      {/* BADGES NO MODO CARD - MANTIDAS DENTRO DA IMAGEM */}
                      <div className="status-badges-container">
                        {card.is_lancamento && (
                          <div className="status-badge-base badge-lancamento">
                            Lançamento
                          </div>
                        )}
                        {card.posicaoImovel && (
                          <div
                            className={`status-badge-base ${card.posicaoImovel === "Em construção" ? "badge-construcao" : "badge-entregue"}`}
                          >
                            {card.posicaoImovel === "Em construção" ? "Construção" : card.posicaoImovel}
                          </div>
                        )}
                      </div>

                      <img
                        src={
                          card.imagens?.[0] ||
                          "https://www.zapimoveis.com.br/blog/wp-content/uploads/2024/10/o-que-fazer-em-praia-grande.jpg"
                        }
                        alt={`Imagem do Imóvel: ${card.tipoImovel} em ${card.bairro}`}
                      />
                      <div className="image-overlay">
                        <button
                          className="view-more-button"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (isSelectionMode) {
                              if (Date.now() - lastTouchTime.current < 500) return;
                              toggleSelectId(card.id);
                            } else {
                              handleCardClick(card);
                            }
                          }}
                        >
                          {isSelectionMode ? (selectedIds.has(card.id) ? "Selecionado ✓" : "Selecionar") : "Mais Detalhes"}
                        </button>
                      </div>
                    </div>
                    <div
                      className="property-data"
                      onClick={!isSelectionMode ? () => handleCardClick(card) : undefined}
                    >
                      <h2>
                        {`${
                          card.tipoImovel === "Apartamento"
                            ? "APTO. "
                            : `${card.tipoImovel?.toUpperCase()} `
                        }${
                          card.dorms
                            ? card.dorms === 1
                              ? `${card.dorms} DORMITÓRIO - `
                              : `${card.dorms} DORMITÓRIOS - `
                            : ""
                        }${
                          card.nomeResidencial
                            ? `${card.nomeResidencial?.toUpperCase()} `
                            : ""
                        }${
                          card.bairro ? `- ${card.bairro?.toUpperCase()}` : ""
                        }${card.statusImovel !== "Venda" ? ` - (${card.statusImovel.toUpperCase()})` : ""}`}
                      </h2>
                      <div className="container-data adress">
                        <i>
                          <FaMapMarkerAlt />
                        </i>
                        <p>{`${card.logradouro || "Rua não informada"}, ${
                          card.numero || "S/N"
                        }${card.complemento ? `, ${card.complemento}` : ""} - ${
                          card.bairro
                        }, ${card.cidade}/${card.estado}`}</p>
                      </div>
                      <div className="container-values">
                        <div className="container-data value-total">
                          <span>Valor: </span>
                          <p>{formatMoney(card.valor)}</p>
                        </div>
                        <div className="container-data">
                          <span>IPTU: </span>
                          <p>{formatMoney(card.iptu)}</p>
                        </div>
                        {Number(card.condominio) > 0 && (
                          <div className="container-data">
                            <span>Condomínio: </span>
                            <p>{formatMoney(card.condominio)}</p>
                          </div>
                        )}
                        <div className="container-data">
                          <span>Financiamento Direto:</span>
                          <p>
                            {card.financiamentoDireto ? "Sim" : "Não"}
                          </p>
                        </div>
                        {card.comissao !== null &&
                          card.comissao !== undefined && (
                            <div className="container-data">
                              <span>Comissão: </span>
                              <p>{formatarComissao(card.comissao)}</p>
                            </div>
                          )}
                        {card.anoEntregaImovel && (
                          <div className="container-data">
                            <span>Entrega prevista para: </span>
                            <p>
                              {card.mesEntregaImovel
                                ? `${monthNames[card.mesEntregaImovel - 1]}/${card.anoEntregaImovel}`
                                : card.anoEntregaImovel}
                            </p>
                          </div>
                        )}
                      </div>

                      <div className="property-features">
                        {card.dorms > 0 && (
                          <span
                            className="container-feature"
                            title={`${card.dorms} Dormitórios`}
                          >
                            <i>
                              <FaBed />
                            </i>
                            <p>
                              {card.dorms} DORM{card.dorms > 1 && "S"}
                            </p>
                          </span>
                        )}
                        {card.banheiros > 0 && (
                          <span
                            className="container-feature"
                            title={`${card.banheiros} Banheiros`}
                          >
                            <i>
                              <MdBathroom />
                            </i>
                            <p>{card.banheiros} WC</p>
                          </span>
                        )}
                        {card.suites > 0 && (
                          <span
                            className="container-feature"
                            title={`${card.suites} Suítes`}
                          >
                            <i>
                              <GiBed />
                            </i>
                            <p>
                              {card.suites} SUÍTE{card.suites > 1 && "S"}
                            </p>
                          </span>
                        )}
                        {card.garagens > 0 && (
                          <span
                            className="container-feature"
                            title={`${card.garagens} Vagas de Garagem`}
                          >
                            <i>
                              <FaCar />
                            </i>
                            <p>
                              {card.garagens} VAGA{card.garagens > 1 && "S"}
                            </p>
                          </span>
                        )}
                        {showLazer && (
                          <span
                            className="container-feature"
                            title="Lazer Completo"
                          >
                            <i>
                              <AiFillLike />
                            </i>
                            <p>LAZER COMPLETO</p>
                          </span>
                        )}
                        {showPiscina && (
                          <span className="container-feature" title="Piscina">
                            <i>
                              <FaSwimmingPool />
                            </i>
                            <p>PISCINA</p>
                          </span>
                        )}
                        {showMobiliado && (
                          <span className="container-feature" title="Mobiliado">
                            <i>
                              <RiSofaFill />
                            </i>
                            <p>MOBILIADO</p>
                          </span>
                        )}
                        {showEdicula && (
                          <span
                            className="container-feature"
                            title="Com Edícula"
                          >
                            <i>
                              <GiBarbecue />
                            </i>
                            <p>C/ EDÍCULA</p>
                          </span>
                        )}
                        {showFrenteMar && (
                          <span
                            className="container-feature"
                            title="Frente ao Mar"
                          >
                            <i>
                              <TbBeach />
                            </i>
                            <p>FRENTE AO MAR</p>
                          </span>
                        )}
                        {showVistaMar && (
                          <span
                            className="container-feature"
                            title="Vista ao Mar"
                          >
                            <i>
                              <TbBeach />
                            </i>
                            <p>VISTA AO MAR</p>
                          </span>
                        )}
                        {showProxPraia && (
                          <span
                            className="container-feature"
                            title="Próximo a Praia"
                          >
                            <i>
                              <FaUmbrellaBeach />
                            </i>
                            <p>PRÓX. A PRAIA</p>
                          </span>
                        )}
                        {card.permuta && (
                          <span
                            className="container-feature"
                            title="Aceita Permuta"
                          >
                            <i>
                              <TbCashRegister />
                            </i>
                            <p>PERMUTA</p>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="container-data container-responsible">
                      <span>Responsável: </span>
                      <p>
                        {realEstateInfoById[card.real_estate_id]?.name ||
                          "Não informado"}{" "}
                        (
                        {realEstateInfoById[card.real_estate_id]?.type || "N/A"}
                        )
                      </p>
                    </div>
                  </article>
                );
              })
            ) : (
              <ul className="view-in-line">
                {propertiesToRender.map((item) => {
                  const showLazer = checkFeature(item, "has_full_leisure", [
                    "Lazer Completo",
                  ]);
                  const showPiscina = checkFeature(item, "has_pool", [
                    "Piscina",
                  ]);
                  const showMobiliado = checkFeature(item, "is_furnished", [
                    "Mobiliado",
                  ]);
                  const showEdicula = checkFeature(item, "has_edicule", [
                    "Com Edícula",
                    "Edicula",
                    "Edícula",
                  ]);
                  const showFrenteMar = checkFeature(item, "is_seafront", [
                    "Frente ao Mar",
                    "Frente Mar",
                  ]);
                  const showVistaMar = checkFeature(item, "has_sea_view", [
                    "Vista ao Mar",
                    "Vista para o Mar",
                    "Vista Mar",
                  ]);
                  const showProxPraia = checkFeature(item, "is_near_beach", [
                    "Próximo a Praia",
                    "Perto da Praia",
                  ]);

                  const isSelectedItem = selectedIds.has(item.id);
                  return (
                    <li
                      key={item.id}
                      className={`property-list-in-line${isSelectionMode ? " selection-mode" : ""}${isSelectedItem ? " card-selected" : ""}`}
                      onTouchStart={isSelectionMode ? (e) => {
                        touchStartPos.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
                        touchMoved.current = false;
                      } : undefined}
                      onTouchMove={isSelectionMode ? (e) => {
                        if (touchMoved.current) return;
                        const dx = Math.abs(e.touches[0].clientX - touchStartPos.current.x);
                        const dy = Math.abs(e.touches[0].clientY - touchStartPos.current.y);
                        if (dx > 10 || dy > 10) touchMoved.current = true;
                      } : undefined}
                      onTouchEnd={isSelectionMode ? (e) => {
                        if (touchMoved.current) return;
                        if (Date.now() - lastTouchTime.current < 50) return;
                        lastTouchTime.current = Date.now();
                        toggleSelectId(item.id);
                      } : undefined}
                      onClick={isSelectionMode ? () => {
                        if (touchMoved.current) return;
                        if (Date.now() - lastTouchTime.current < 500) return;
                        toggleSelectId(item.id);
                      } : () => handleCardClick(item)}
                    >
                      <div className="container-image-list">
                        {item.area > 0 && <span>{item.area} m²</span>}
                        {/* AQUI: Removi as badges de dentro da imagem */}
                        <img
                          src={
                            item.imagens?.[0] ||
                            "https://www.zapimoveis.com.br/blog/wp-content/uploads/2024/10/o-que-fazer-em-praia-grande.jpg"
                          }
                          alt={`Imagem do imóvel ${item.tipoImovel}`}
                        />
                      </div>

                      <div className="list-content-wrapper">
                        <div className="list-info-left">
                          <h3>
                            {`${
                              item.tipoImovel === "Apartamento"
                                ? "APTO. "
                                : `${item.tipoImovel?.toUpperCase()} `
                            }${
                              item.dorms
                                ? item.dorms === 1
                                  ? `${item.dorms} DORMITÓRIO - `
                                  : `${item.dorms} DORMITÓRIOS - `
                                : ""
                            }${
                              item.nomeResidencial
                                ? `${item.nomeResidencial.toUpperCase()} `
                                : ""
                            }${
                              item.bairro
                                ? `- ${item.bairro.toUpperCase()}`
                                : ""
                            }${item.statusImovel !== "Venda" ? ` - (${item.statusImovel.toUpperCase()})` : ""}`}
                          </h3>

                          <p className="list-item-address">
                            <FaMapMarkerAlt />{" "}
                            {`${item.logradouro || "Rua não informada"}, ${
                              item.numero || "S/N"
                            }${
                              item.complemento ? `, ${item.complemento}` : ""
                            } - ${item.bairro}, ${item.cidade}/${item.estado}`}
                          </p>

                          <div className="list-item-details-row">
                            <span className="detail-group">
                              <b>Valor:</b> {formatMoney(item.valor)}
                            </span>
                            <span className="detail-group">
                              <b>IPTU:</b> {formatMoney(item.iptu)}
                            </span>
                            {Number(item.condominio) > 0 && (
                              <span className="detail-group">
                                <b>Condomínio:</b>{" "}
                                {formatMoney(item.condominio)}
                              </span>
                            )}
                            {item.comissao !== null &&
                              item.comissao !== undefined && (
                                <span className="detail-group">
                                  <b>Comissão:</b>{" "}
                                  {formatarComissao(item.comissao)}
                                </span>
                              )}
                            {item.anoEntregaImovel && (
                              <span className="detail-group">
                                <b>Entrega prevista para:</b>{" "}
                                {item.mesEntregaImovel
                                  ? `${monthNames[item.mesEntregaImovel - 1]}/${item.anoEntregaImovel}`
                                  : item.anoEntregaImovel}
                              </span>
                            )}
                          </div>

                          <p className="list-item-responsible">
                            <b>Responsável:</b>{" "}
                            {realEstateInfoById[item.real_estate_id]?.name ||
                              "Não informado"}{" "}
                            (
                            {realEstateInfoById[item.real_estate_id]?.type ||
                              "N/A"}
                            )
                          </p>

                          {/* AQUI: Adicionei as badges na coluna de texto (igual a Home) */}
                          <div className="status-badges-container">
                            {item.is_lancamento && (
                              <div className="status-badge-base badge-lancamento">
                                Lançamento
                              </div>
                            )}
                            {item.posicaoImovel && (
                              <div
                                className={`status-badge-base ${item.posicaoImovel === "Em construção" ? "badge-construcao" : "badge-entregue"}`}
                              >
                                {item.posicaoImovel === "Em construção" ? "Construção" : item.posicaoImovel}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="list-info-right">
                          {item.dorms > 0 && (
                            <span
                              className="list-feature-card-blue"
                              title={`${item.dorms} Dormitórios`}
                            >
                              <i>
                                <FaBed />
                              </i>
                              <p>
                                {item.dorms} DORM{item.dorms > 1 && "S"}
                              </p>
                            </span>
                          )}
                          {item.banheiros > 0 && (
                            <span
                              className="list-feature-card-blue"
                              title={`${item.banheiros} Banheiros`}
                            >
                              <i>
                                <MdBathroom />
                              </i>
                              <p>{item.banheiros} WC</p>
                            </span>
                          )}
                          {item.suites > 0 && (
                            <span
                              className="list-feature-card-blue"
                              title={`${item.suites} Suítes`}
                            >
                              <i>
                                <GiBed />
                              </i>
                              <p>
                                {item.suites} SUÍTE{item.suites > 1 && "S"}
                              </p>
                            </span>
                          )}
                          {item.garagens > 0 && (
                            <span
                              className="list-feature-card-blue"
                              title={`${item.garagens} Vagas`}
                            >
                              <i>
                                <FaCar />
                              </i>
                              <p>
                                {item.garagens} VAGA{item.garagens > 1 && "S"}
                              </p>
                            </span>
                          )}
                          {showLazer && (
                            <span
                              className="list-feature-card-blue"
                              title="Lazer Completo"
                            >
                              <i>
                                <AiFillLike />
                              </i>
                              <p>LAZER COMPLETO</p>
                            </span>
                          )}
                          {showPiscina && (
                            <span
                              className="list-feature-card-blue"
                              title="Piscina"
                            >
                              <i>
                                <FaSwimmingPool />
                              </i>
                              <p>PISCINA</p>
                            </span>
                          )}
                          {showMobiliado && (
                            <span
                              className="list-feature-card-blue"
                              title="Mobiliado"
                            >
                              <i>
                                <RiSofaFill />
                              </i>
                              <p>MOBILIADO</p>
                            </span>
                          )}
                          {showEdicula && (
                            <span
                              className="list-feature-card-blue"
                              title="Com Edícula"
                            >
                              <i>
                                <GiBarbecue />
                              </i>
                              <p>C/ EDÍCULA</p>
                            </span>
                          )}
                          {showFrenteMar && (
                            <span
                              className="list-feature-card-blue"
                              title="Frente ao Mar"
                            >
                              <i>
                                <TbBeach />
                              </i>
                              <p>FRENTE AO MAR</p>
                            </span>
                          )}
                          {showVistaMar && (
                            <span
                              className="list-feature-card-blue"
                              title="Vista ao Mar"
                            >
                              <i>
                                <TbBeach />
                              </i>
                              <p>VISTA AO MAR</p>
                            </span>
                          )}
                          {showProxPraia && (
                            <span
                              className="list-feature-card-blue"
                              title="Próximo a Praia"
                            >
                              <i>
                                <FaUmbrellaBeach />
                              </i>
                              <p>PRÓX. A PRAIA</p>
                            </span>
                          )}
                          {item.permuta && (
                            <span
                              className="list-feature-card-blue"
                              title="Aceita Permuta"
                            >
                              <i>
                                <TbCashRegister />
                              </i>
                              <p>PERMUTA</p>
                            </span>
                          )}
                        </div>
                      </div>

                      {isSelectionMode ? (
                        <button
                          className="bt-favorite-list bt-selection-checkbox"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSelectId(item.id);
                          }}
                        >
                          <i>
                            {isSelectedItem ? <BsCheckSquareFill /> : <MdCheckBoxOutlineBlank />}
                          </i>
                        </button>
                      ) : (
                        <button
                          className="bt-favorite-list"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleFavorite(item.id);
                          }}
                        >
                          <i>
                            {userFavorites.includes(item.id) ? (
                              <FaStar />
                            ) : (
                              <FaRegStar />
                            )}
                          </i>
                        </button>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
          </section>

          <div
            className="pagination-container"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "20px",
              padding: "15px 0",
              marginTop: "0px",
            }}
          >
            <div
              className="pagination-controls"
              style={{ display: "flex", alignItems: "center", gap: "15px" }}
            >
              <button
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  opacity: currentPage === 1 ? 0.5 : 1,
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FaChevronLeft />
              </button>

              <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                Página {currentPage} de {totalPages}
              </span>

              <button
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
                style={{
                  background: "none",
                  border: "none",
                  cursor:
                    currentPage === totalPages ? "not-allowed" : "pointer",
                  opacity: currentPage === totalPages ? 0.5 : 1,
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FaChevronRight />
              </button>
            </div>
          </div>
        </>
      )}
      {isSelectionMode && selectedIds.size > 0 && (
        <>
          {showSelectedList && (
            <div className="batch-selected-list">
              {filteredData
                .filter((p) => selectedIds.has(p.id))
                .map((p) => (
                  <div key={p.id} className="batch-selected-item">
                    <img
                      src={p.imagens?.[0] || "https://www.zapimoveis.com.br/blog/wp-content/uploads/2024/10/o-que-fazer-em-praia-grande.jpg"}
                      alt=""
                      className="batch-selected-thumb"
                    />
                    <span className="batch-selected-name">
                      {p.tipoImovel === "Apartamento" ? "Apto. " : `${p.tipoImovel} `}
                      {p.dorms ? `${p.dorms} dorm. ` : ""}
                      {p.nomeResidencial ? `- ${p.nomeResidencial} ` : ""}
                      {p.bairro ? `- ${p.bairro}` : ""}
                    </span>
                    <button
                      className="batch-selected-remove"
                      onClick={() => toggleSelectId(p.id)}
                    >
                      ×
                    </button>
                  </div>
                ))}
            </div>
          )}
          <div className="batch-action-bar">
            <button
              className="batch-toggle-list"
              onClick={() => setShowSelectedList((v) => !v)}
              title={showSelectedList ? "Ocultar lista" : "Ver selecionados"}
            >
              <i>{showSelectedList ? <MdExpandMore /> : <MdExpandLess />}</i>
              <span className="batch-count">
                {selectedIds.size} {selectedIds.size !== 1 ? "selecionados" : "selecionado"}
              </span>
            </button>
            <div className="batch-actions">
              <button className="batch-btn-cancel" onClick={toggleSelectionMode}>
                Cancelar
              </button>
              <button className="batch-btn-delete" onClick={() => setShowDeleteModal(true)}>
                Excluir
              </button>
            </div>
          </div>
        </>
      )}

      <ModalConfirmAction
        isOpen={showDeleteModal}
        title="Excluir imóveis"
        descriptionAction={`Tem certeza que deseja excluir ${selectedIds.size} imóvel${selectedIds.size !== 1 ? "s" : ""}? Esta ação não pode ser desfeita.`}
        buttonConfirmAction={handleConfirmBatchDelete}
        textButtonConfirmAction={deletingBatch ? "Excluindo..." : "Excluir"}
        buttonCancelAction={() => setShowDeleteModal(false)}
        textButtonCancelAction="Cancelar"
      />

      <ModalMessage
        isOpen={!!showSuccessModal}
        title="Imóveis removidos"
        descriptionAction={`${showSuccessModal} imóvel${showSuccessModal !== 1 ? "s" : ""} removido${showSuccessModal !== 1 ? "s" : ""} com sucesso.`}
        buttonConfirmAction={() => setShowSuccessModal(false)}
      />

      {showScrollTop && (
          <button
            onClick={scrollToTop}
            title="Voltar ao topo"
            style={{
              position: "fixed",
              bottom: "40px",
              right: "40px",
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              backgroundColor: "#021954", 
              color: "#fff",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "20px",
              cursor: "pointer",
              boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
              zIndex: 1000,
              transition: "opacity 0.3s ease-in-out"
            }}
          >
            <FaArrowUp />
          </button>
        )}
    </>
  );
}